var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#7286e9",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,60.0083941 C63,52.2717717 69.2663135,46 77,46 C84.7319865,46 91,52.2733516 91,60.0083941 L91,139.991606 C91,147.728228 84.7336865,154 77,154 C69.2680135,154 63,147.726648 63,139.991606 L63,60.0083941 Z M109,60.0083941 C109,52.2717717 115.266313,46 123,46 C130.731986,46 137,52.2733516 137,60.0083941 L137,139.991606 C137,147.728228 130.733687,154 123,154 C115.268014,154 109,147.726648 109,139.991606 L109,60.0083941 Z",
    fill: "#FDFFFC"
  }))));
}

export default SvgAudioPause;